import { Snackbar, useSnackbar } from "@hireart/component-library";

// Relocated verbatim from the legacy hireart-components package (EE-1386) so
// call sites stop depending on it. useSnackbar is not a stateful hook - it
// returns imperative snackbar emitters, and the legacy bridge already called
// it at module scope.
// eslint-disable-next-line react-hooks/rules-of-hooks
const { showError, showSuccess, showInfo, showWarning, show } = useSnackbar();

export const Toasts = {
  error(msg) {
    return showError(msg);
  },
  success(msg) {
    return showSuccess(msg);
  },
  warning(msg) {
    return showWarning(msg);
  },
  info(msg) {
    return showInfo(msg);
  },
  neutral(msg) {
    return show(msg);
  },
  Container: Snackbar,
};
